const selector = (state) => state.get('alertsConfiguration');

export const selectedDefinitionsSelector = (state) => selector(state).get('selectedDefinitions');
